import { CHUser } from "../tsClasses/CHTypes";
import { apiPath } from "./GeneralFunc";

type AddUserFuncProps = {
  userToAdd : CHUser,
  userToken: string,
}

const AddUserFunc = async (props : AddUserFuncProps) => {
    
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json", token: props.userToken },
      body: JSON.stringify(props.userToAdd),
    };

  
    try {
      const response = await fetch(
        apiPath+"/admin/addUser",
        requestOptions
      );
      if (response.status == 401) {
        return "Unauthorized";
      }
      if (response == null) {
      }
  
      const result = await response.text();
      return result;
    } catch (error) {
      return "gotErr";
    }
  };
  export default AddUserFunc;